// Centralized version configuration
// Update this single location to change the version across the entire app
export const APP_VERSION = "v27.0.5";

// Optional: You can also add build info or other version-related constants here
//We'll do our version bumps here.
export const BUILD_DATE = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
export const VERSION_DISPLAY = APP_VERSION; // Can be customized for different display formats
